module.exports = __webpack_public_path__ + "img/益视说明书_22.6b1a34c7.png";